import React from "react";
import {Button, Container} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {TemplateItemModel} from "../../models/TemplateModel";
import TemplateDetails from "./TemplateDetail";

interface TemplateViewProps {
    template: {
        id: string;
        name: string;
        description: string;
        items: TemplateItemModel[];
    };
    onBack: () => void;
}

const TemplateView: React.FC<TemplateViewProps> = ({template, onBack}) => {
    return (
        <Container maxWidth="md">
            <Button startIcon={<ArrowBackIcon/>} onClick={onBack} sx={{mb: 2}}>
                Terug naar lijst
            </Button>
            <TemplateDetails template={template}/>
        </Container>
    );
};

export default TemplateView;
